import React, { FC } from 'react'
import { IconSystemReminder } from '@moonpig/launchpad-assets'
import { system as s } from '@moonpig/launchpad-system'
import { Flex, Text } from '@moonpig/launchpad-components'
import { styled } from '@moonpig/launchpad-utils'
import { ReminderRow } from '../types'
import { LIST_ICON_SIZE_PX } from '../constants'
import { useLocaleText } from '../../locale'

export type Reminder = {
  id: string
  value: string
  occasion: string
  date: Date
}

const StyledIconSystemReminder = styled(IconSystemReminder)`
  ${s({ color: 'colorInteractionControl' })}
  width: ${LIST_ICON_SIZE_PX};
  height: ${LIST_ICON_SIZE_PX};
`

const StyledIconWrapper = styled(Flex)`
  ${s({
    borderRadius: 1,
    p: 4,
    mr: 4,
    bgcolor: 'colorBackground01',
    color: 'colorInteractionControl',
  })}
`

export const Reminder: FC<{ row: ReminderRow }> = ({ row }) => {
  const item = row.item
  const localiseText = useLocaleText()
  const daysUntilText = localiseText('search.reminder.date', {
    dateOfEvent: item.date,
  })

  return (
    <Flex alignItems="center">
      <StyledIconWrapper>
        <StyledIconSystemReminder data-testid="lp-nav-search-reminder-icon" />
      </StyledIconWrapper>
      <Text className="mp-mask">
        {item.value}{' '}
        <Text color="colorBlack60" typography="typeBodyText">
          {daysUntilText}
        </Text>
      </Text>
    </Flex>
  )
}
